<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品名称：">
                <el-input v-model.trim="searchForm.pkgName" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle">搜索查询</el-button>
                <el-button type="primary" @click="showAddPkg">新增商品</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >           
            <el-table-column prop="id" label="系统编码" width="150px"></el-table-column>
            <el-table-column prop="pkgName" label="商品名称"></el-table-column>
             <el-table-column prop="shopInfo" label="商品返利说明"></el-table-column>
             <el-table-column label="产品图片">
　   　     <template slot-scope="scope">
　　　     　<img :src="getImgUrl() +  scope.row.shopImgss" width="60" height="60" class="head_pic"/>
　         　</template>
           </el-table-column>
            <!-- <el-table-column label="产品介绍图片">
　   　     <template slot-scope="scope">
　　　     　<img :src="scope.row.shopHeadImgs" width="60" height="60" class="head_pic"/>
　         　</template>
           </el-table-column> -->
            <el-table-column prop="supplierName" label="运营商名称"></el-table-column>
            <el-table-column prop="stateName" label="状态" width="120px"></el-table-column>
            <el-table-column prop="createTime" label="添加时间" width="200px"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showEditPkg(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="showEditPkg1(scope.row)">推广链接</el-button>
                </template>             
            </el-table-column>
        </el-table>  
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">                
                <el-form-item label="商品名称:" prop="pkgName">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.pkgName" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="商品展示图(建议像素512*512)：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">商品图：</div>
                            <img v-else :src="getImgUrl() +  addOrEditPkgForm.shopImgss" alt="" width="150" height="150">  
                </el-form-item>
                  <el-form-item label="商品介绍图(建议像素1080*450)：">
                    <input  type="file" ref="file2">
                    <div v-if="!existBackImg">介绍图：</div>
                            <img v-else :src="getImgUrl() +  addOrEditPkgForm.shopHeadImgs" alt="" width="150" height="150">  
                </el-form-item>
                 
                <el-form-item label="返利说明:" prop="shopInfo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.shopInfo" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="运营商名称:" prop="supplierName">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.supplierName" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                     <el-form-item label="账号:" prop="account">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.account" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                     <el-form-item label="密码:" prop="pwd">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.pwd" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="状态：" prop="state">
                    <el-col :span="22">
                        <el-select v-model="addOrEditPkgForm.state" clearable>
                            <el-option v-for="item in pkgStatesOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item> 
                 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>            

        </el-dialog>
               <el-dialog :append-to-body="true"  :title="title" :visible.sync="shareImgs" width="600px" @close="cancel" :close-on-click-modal="false">
                   <p>
                       备注：
                   </p>
                   <p>
                       1： 请保存以下二维码进行推广商品，商品推广后 可在客服管理->申请列表里面查询
                   </p>
                   <p>
                          2：  也可以使用此链接进行推广  {{urls}}
                   </p>
            <div style="text-align: center; width: 500px; border: ">               
               <img  :src="getImgUrl() +  addOrEditPkgForm.shareImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancel">确 定</el-button>
            </div>            

        </el-dialog>
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){     
        return {
            shareImgs:false,
            frontImgUrl:'',
            existBackImg:false,
            searchForm: {
                typeGroupId: '',
                type: '',
                supplierType: '',
                shopState: null,
                pkgName: '',
                state:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':0,'description':'禁用'},
              {'code':1,'description':'启用'}
            ],
              pkgStatesOption: [
                {'code':0,'description':'禁用'},
              {'code':1,'description':'启用'}
            ],
             agentStateOption: [
                {'code':1,'description':'允许'},
              {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                shopImgss:'',
                shopHeadImgs:'',
                state:'',
                pkgName:'',
                shopImgs: '',
                shopState: '',
                name:'',
                nameUrl:'',
                supplierName:'',
                account:'',
                pwd:'',
                pwdkey:'11',
                shareImg:'',
                shopInfo:''
                         
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: '',
            message:'',
            urls:''
        }
    },
    methods: {
        cancel(){
            this.shareImgs=false;
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '上架', 1: '下架'})
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                 common.sysRequest('app/pc/share/list', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },
        showEditPkg1(row){
         var data = {
                id: row.id
            }
             common.sysRequest('app/pc/share/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                   this.addOrEditPkgForm.shareImg=res.data.data.img;
                   this.shareImgs=true;
                   this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }})
        },
        showEditPkg(row){
            this.existBackImg=true;
            this.frontImgUrl=true;
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改商品';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            this.existBackImg=true;

            common.sysRequest("app/pc/share/info", data, 'post').then(res=>{
                     var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    
                        this.addOrEditPkgForm[key] = result[key]
                }        
                      }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
            this.$refs.addOrEditPkgForm.validate(valid => {
                if(valid) {
                    let fd = new FormData();
            Object.keys(this.addOrEditPkgForm).forEach((key) => {
                fd.append(key, this.addOrEditPkgForm[key]);
            })
            fd.append('appPopImg',this.$refs.file1.files[0]);
            fd.append('appTImg',this.$refs.file2.files[0]);
                    if(this.addFlag == true){
                        common.sysRequest("app/pc/insert/share", fd, 'post').then(res=>{
                                if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                     callback(res);
                            for (let val in this.addOrEditPkgForm) {
                                this.addOrEditPkgForm[val] = "";
                            }

                            }else{
                                this.$message.error(res.data.message);
                            }
                      }).catch(err=> console.error(err));
                    }else{
                         let fds = new FormData();
                         fds.append('id',this.currentId);
                         fds.append('appPopImg',this.$refs.file1.files[0]);
                         fds.append('appTImg',this.$refs.file2.files[0]);
                          fds.append('state',this.addOrEditPkgForm.state);
                           fds.append('pkgName',this.addOrEditPkgForm.pkgName);
                        fds.append('account',this.addOrEditPkgForm.account);
                        fds.append('pwd',this.addOrEditPkgForm.pwd);
                        fds.append('pwdkey',this.addOrEditPkgForm.pwdkey);
                        fds.append('shopInfo',this.addOrEditPkgForm.shopInfo);
                         fds.append('supplierName',this.addOrEditPkgForm.supplierName);
                           common.sysRequest("app/pc/update/share", fds, 'post').then(res=>{
                             if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                 callback(res);
                            }else{
                                this.$message.error(res.data.message);
                            }
                           
                      }).catch(err=> console.error(err));             
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
            })             
        },
        changePkgStateHandle(id){
            var data = {
                id
            }
            changePkgState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getPkgListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
             common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                    if(res.data.code == 200){
                    this.getPkgListPageHandle();
                   }
                })
            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
        this.getPkgListPageHandle();
         common.sysRequest('app/pc/share/info/list', {}, 'post').then(res => {
                    if(res.data.code == 200){
                        this.supplierOption = res.data.data;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
    }  
}
</script>
<style lang="less" >
.input-with-select .el-input {
    width: 60px;
}
</style>

